import React, { useState } from 'react';

const ThumbnailSlider = ({ 
    thumbnailImages, 
    selectedRepImage, 
    selectedThumbnails, 
    onThumbnailSelect, 
    onThumbnailCheckbox,
    onThumbnailReorder
}) => {
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);

    if (!thumbnailImages || thumbnailImages.length === 0) {
        return null;
    }

    const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', index.toString());
        e.target.style.opacity = '0.5';
    };

    const handleDragEnd = (e) => {
        e.target.style.opacity = '1';
        setDraggedIndex(null);
        setDragOverIndex(null);
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverIndex(index);
    };

    const handleDragLeave = (e) => {
        // 드래그가 실제로 떠났는지 확인
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setDragOverIndex(null);
        }
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'));
        
        if (draggedIndex !== null && draggedIndex !== dropIndex) {
            onThumbnailReorder(draggedIndex, dropIndex);
        }
        
        setDragOverIndex(null);
    };

    return (
        <div className="bg-white rounded-lg p-4 border">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">썸네일 (드래그하여 순서 변경)</h3>
            <div className="flex gap-3 overflow-x-auto pb-2">
                {thumbnailImages.map((image, index) => (
                    <div 
                        key={`${image}-${index}`} 
                        className={`flex-shrink-0 relative group transition-all duration-200 ${
                            dragOverIndex === index && draggedIndex !== index 
                                ? 'transform scale-105' 
                                : ''
                        }`}
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragEnd={handleDragEnd}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDragLeave={handleDragLeave}
                        onDrop={(e) => handleDrop(e, index)}
                    >
                        <div className="relative">
                            <img
                                src={image}
                                alt={`썸네일 ${index + 1}`}
                                className={`w-20 h-20 object-cover rounded cursor-pointer border-2 transition-all ${
                                    selectedRepImage === image 
                                        ? 'border-blue-500 ring-2 ring-blue-200' 
                                        : 'border-gray-200 hover:border-gray-400'
                                } ${draggedIndex === index ? 'opacity-50' : ''} ${
                                    dragOverIndex === index && draggedIndex !== index 
                                        ? 'border-blue-600 ring-2 ring-blue-400' 
                                        : ''
                                }`}
                                onClick={() => onThumbnailSelect(index)}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'flex';
                                }}
                            />
                            <div 
                                className="w-20 h-20 bg-gray-200 rounded flex items-center justify-center text-xs text-gray-500 border-2 border-gray-200"
                                style={{ display: 'none' }}
                            >
                                오류
                            </div>
                            
                            {/* 체크박스 */}
                            <div className="absolute top-1 left-1">
                                <input
                                    type="checkbox"
                                    checked={selectedThumbnails.has(index)}
                                    onChange={() => onThumbnailCheckbox(index)}
                                    className="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </div>

                            {/* 드래그 핸들 */}
                            <div className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity">
                                <div className="w-4 h-4 bg-gray-600 rounded flex items-center justify-center cursor-move">
                                    <svg className="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                                    </svg>
                                </div>
                            </div>

                            {/* 순서 번호 표시 */}
                            <div className="absolute bottom-1 right-1 bg-black bg-opacity-50 text-white text-xs px-1 rounded">
                                {index + 1}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            
            {/* 선택된 썸네일 개수 표시 */}
            <div className="mt-3 text-sm text-gray-600">
                선택된 이미지: {selectedThumbnails.size} / {thumbnailImages.length}
            </div>
        </div>
    );
};

export default ThumbnailSlider;
